import { useEffect, useState } from "react";
import { useInterval } from "library/core/utility/hooks/interval";
import camsAudio from "library/core/utility/audio";
import { PAUSED_SHOW_COUNTER_SECONDS } from "./_stores/broadcast/consts";

const usePausedShowCountdown = (
  restoreFreeShow: () => Promise<void>,
  broadcasterVariant: string
): number => {
  const [timer, setTimer] = useState<number>(PAUSED_SHOW_COUNTER_SECONDS);
  const [hasTimerExpired, setHasTimerExpired] = useState<boolean>(false);

  useInterval(() => {
    if (timer > 0) {
      setTimer(timer - 1);
    } else if (timer === 0) {
      // this fires twice therefore use the method with useState and useEffect
      // useEffect does not fire a second time when value is already true
      setHasTimerExpired(true);
    }
  }, 1000);

  useEffect(() => {
    if (timer === PAUSED_SHOW_COUNTER_SECONDS) {
      camsAudio.playEndPrivateChat();
    }
  }, []); //private show ending at start of timer audio

  useEffect(() => {
    if (hasTimerExpired) {
      restoreFreeShow();
    }
  }, [hasTimerExpired]);

  useEffect(() => {
    if (broadcasterVariant === "member-verification") {
      restoreFreeShow();
    }

    return () => {
      setTimer(PAUSED_SHOW_COUNTER_SECONDS);
      setHasTimerExpired(false);
    };
  }, []);

  return timer;
};

export default usePausedShowCountdown;
